import React from 'react';
import {imageUrl} from '../../utilities/requests';


const Invoice = ({school, onLoad}) => {
    // debugger;
    return(
    <div
        style={{
            width: '210mm',
            height: '148mm',
            margin: 0,
            position: 'relative',
            pageBreakAfter: 'always',
            direction: 'rtl',
            lineHeight: '1.9em',
        }}>
        <div
            style={{
                position: 'absolute',
                top: '60mm',
                left: '10mm',
                width: '85mm',
                height: '64mm',
            }}>
        </div>
        <div
            style={{
                position: 'absolute',
                top: '10mm',
                left: '10mm',
                width: '85mm',
                fontSize: '1.2em',
            }}>
            <div style={{width: '100%', height: '100%', position: 'relative'}}>
                <span style={{fontSize: '1.5em', fontWeight: '700'}}>
                    {window.pgettext('invoice', 'From')}:&nbsp;
                </span>
                <span style={{fontSize: '1.2em'}}>
                    تهران
                </span>
                <br/>
                میدان فردوسی – نبش خیابان براتی – پلاک ۱۶
                <br/>
                واحد ۱۴
                <br/>
                کدپستی  ۱۱۳۱۸۵۶۶۴۴
                <br/>
                شماره تماس :&nbsp;
                <span style={{unicodeBidi: 'plaintext'}}>
                    ۰۲۱-۶۶۷۴۴۳۸۴-۵
                </span>
                <br/>
                <b>
                    مؤسسه آموزشی علامه حلی
                </b>
            </div>
        </div>
        <div
            style={{
                position: 'absolute',
                top: '84mm',
                right: '10mm',
                width: '98mm',
                fontSize: '1.2em',
            }}>
            <span style={{fontSize: '1.5em', fontWeight: '700'}}>
                {window.pgettext('invoice', 'To')}:&nbsp; 
            </span>
            <span style={{fontSize: '1.2em'}}>
                {school?.city.region_display} - {school?.city.name}
            </span>
            <br/>
            {school?.address ? school?.address.persian() : '-'} 
            <br/>
            {school?.postal_code ? window.gettext('Postal Code') + ': ' + school?.postal_code.persian() : null}
            {school?.postal_code ? <br/> : null}   
            {window.gettext('Contact Info')}: {school?.phone_number ? school?.phone_number.persian() : null} -
            &nbsp;
            {school?.executive_assistant_phone_number ? school?.executive_assistant_phone_number.persian() : null}
            <br/>
            <b> 
                {school?.name}
                <br/>
                کد بسته: {school?.id}
            </b>
        </div>
        <div
            style={{
                position: 'absolute', 
                top: '5mm',
                right: '10mm',
                width: '85mm',
                height: '84mm',
                color: '#D10305',
                textAlign: 'center',
            }}>
            <img
                src="image/logo2.png"
                height="170"
                type="contain"
                onLoad={onLoad}
            />
            <br/>
            <br/>
            <div
                style={{
                    fontSize: '2.5em',
                    fontWeight: '700',
                    border: '1mm solid #D10305',
                    borderRadius: '1mm',
                    padding: '.5cm',
                    textAlign: 'center',
                    display: 'inline-block',
                }}>
                {window.gettext('Pishtaz Post')} 
            </div>
        </div>
    </div>
    )
};

export default Invoice;
